




































































import { Component, Vue, Prop } from 'vue-property-decorator';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Modal from '@/components/Modal.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Button,
    Modal,
  },
})

export default class UserProfile extends Vue {
  @Prop(Boolean) requested!: boolean;
  active = false

  toggleActive() {
    this.active = true;
    this.$emit('requestActivate');
  }

  toggleClose() {
    this.active = false;
  }
}
